import { render, staticRenderFns } from "./CongestionamentoViewer.vue?vue&type=template&id=95872750&scoped=true"
import script from "./CongestionamentoViewer.vue?vue&type=script&lang=js"
export * from "./CongestionamentoViewer.vue?vue&type=script&lang=js"
import style0 from "./CongestionamentoViewer.vue?vue&type=style&index=0&id=95872750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95872750",
  null
  
)

export default component.exports